<template>
  <div class="search-bar">
    <div class="main-container clearfix">
      <el-row>
        <el-col :span="5">
          <AirportSelection
            :default-airport="chargeDeparture"
            class="s-search-widths"
            v-bind:prefix-label="'Port of Departure'"
            v-bind:show-hot-import-city="false"
            v-bind:airport-d-b="portDB"
            v-bind:city-d-b="cityDB"
            @update-airport="updateDeparture"
            key="departure"
          >
          </AirportSelection>
        </el-col>
        <el-col :span="5">
          <AirportSelection
            :default-airport="chargeDestination"
            class="s-search-widths s-search-des"
            v-bind:prefix-label="'Port of Destination'"
            v-bind:show-hot-import-city="true"
            v-bind:airport-d-b="portDB"
            v-bind:city-d-b="cityDB"
            @update-airport="updateDestination"
            key="destination"
          >
          </AirportSelection>
        </el-col>
        <el-col :span="5">
          <el-select
            clearable
            class="flight-date-select s-search-com_prefix s-search-widths s-search-airline"
            v-model="chargeAirline"
            filterable
            :filter-method="airLineInputChangeHandler"
            placeholder=""
            no-data-text="Airline Code"
            default-first-option
            popper-class="y-seach-port-select-dropdown"
          >
            <el-option
              v-for="item in airLineOptions"
              :key="item.code"
              :label="item.code"
              :value="item.code"
            >
              <span class="s-search-code">{{ item.code }}</span>
              <span class="s-search-titleZH">{{ item.titleZH }}</span>
            </el-option>
            <template slot="prefix">
              <span class="">{{ $t("header.searchbar.airline") }}</span>
            </template>
          </el-select>
        </el-col>
        <el-col :span="5" class="s-search-picker">
          <el-date-picker
            v-model="chargeDate"
            @change="pickerdate"
            type="date"
            placeholder="Flight Date"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-button
            class="s-search-advanced"
            type="danger"
            icon="el-icon-search"
            @click="advancedQuery()"
          >
            {{ $t("home.book") }}
          </el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <div class="s-search-weight_box">
          <el-col :span="5">
            <el-input
              type="number"
              class="s-search-com_prefix"
              v-model="chargeWeights"
              @change="weightChangeHandler"
              :min="0"
              :max="10000"
              placeholder=""
            >
              <template slot="prefix">
                <span class="">{{ $t("header.searchbar.weight") }}</span>
              </template>
              <template slot="suffix">
                <span class="el-input__suffix">KG</span>
              </template>
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input
              type="number"
              class="s-search-com_prefix"
              v-model="chargeVolume"
              @change="volumeChangeHandler"
              :min="0"
              :max="10000"
              placeholder=""
            >
              <template slot="prefix">
                <span class=""> {{ $t("header.searchbar.volume") }}</span>
              </template>
              <template slot="suffix">
                <span class="el-input__suffix">m³</span>
              </template>
            </el-input>
          </el-col>
        </div>
        <el-col :span="5">
          <el-select
            class="s-search-packagingtype s-search-com_prefix"
            clearable
            v-model="chargeType"
            placeholder=""
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
            <template slot="prefix">
              <span class="">{{ $t("header.searchbar.type") }}</span>
            </template>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-row class="s-search-p_weight">
            <el-col :span="12"
              >{{ $t("header.searchbar.c_weight") }}:{{ chargeCounts }}</el-col
            >
            <el-col :span="10"
              >{{ $t("header.searchbar.proportion") }}:{{
                !!chargeDensity ? "1:" + chargeDensity : ""
              }}</el-col
            >
          </el-row>
        </el-col>
        <el-col :span="4" class="s-search-p_total">
          <div class="s-search-p_box">
            <p>
              <i class="el-icon-warning s-search-pt_icon"></i
              ><span>{{ $t("header.searchbar.tip1") }}</span>
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<style scoped>
@import "./index.css";
</style>
<script type="babel">
import AirportSelection from "@/components/airportSelection/index.vue";
import DBUtils from '@/utils/dbUtils';
export default {
	components: {
		AirportSelection
	},
	data: function () {
		return {
			yunModel: this.$route.meta.yunModel,
			airLineOptions: '',
			AIRLINE_COLLECTIONS: '',
			options: [
				{
					value: "",
					label: "All"
				},
				{
					value: "Bulk",
					label: "Bulk"
				},
				{
					value: "Tray",
					label: "Tray"
				}
			],
			airlineDB: [],
			portDB: [],
			cityDB: [],
            imphotdata: [],
            exphotdata: [],
            emptyArray: [],

		}
	},
	watch: {
		'chargeAirline': {
			handler: function (airline) {
				this.$emit('update-airline', airline);
			}
		},
		'chargeDate': {
			handler: function (flightdate) {
				this.$emit('update-date', flightdate);
			}
		},
		'chargeType': {
			handler: function (packagingtype) {
				this.$emit('update-packtype', packagingtype);
			}
		},
		'chargeDensity': {
			handler: function (density) {
				this.$emit('update-density', density);
			}
		},
		'chargeVolume': {
			handler: function (volume) {
				this.$emit('update-volume', volume);
			}
		},
		'chargeWeights': {
			handler: function (chargeWeight) {
				this.$emit('update-charge-weight', chargeWeight);
			}
		},
		'chargeCounts': {
			handler: function (chargeCount) {
				this.$emit('update-charge-count', chargeCount);
			}
		},
		'chargeDeparture': {
			handler: function (departure) {
				this.$emit('update-departure', departure);
			}
		},
		'chargeDestination': {
			handler: function (destination) {
				this.$emit('update-destination', destination);
			}
		},
	},
	props: {
		chargeDeparture: {
			type: String,
			default: ''
		},
		chargeDestination: {
			type: String,
			default: ''
		},
		chargeWeights: {
			type: String,
			default: ''
		},
		chargeCounts: {
			type: String,
			default: ''
		},
		chargeVolume: {
			type: String,
			default: ''
		},
		chargeDensity: {
			type: String,
			default: ''
		},
		chargeType: {
			type: String,
			default: ''
		},
		chargeAirline: {
			type: String,
			default: ''
		},
		chargeDate: {
			type: String,
			default: ''
		},
	},
	mounted: async function () {
		this.cityDB = await DBUtils.getDBCitys()
		this.airlineDB = await DBUtils.getDBAirlines()
		this.portDB = await DBUtils.getDBPorts()
        this.imphotdata = await DBUtils.getImphotdata()
        this.exphotdata = await DBUtils.getExphotdata()
	},
	methods: {
		// 查询订舱
		advancedQuery: function () {
			var vm = this
			var pathname = window.location.pathname;
			var query={
                sublist: 1,
                pageSize: 10,
                currentPage: 1,
                departure: vm.chargeDeparture,
                destination: vm.chargeDestination,
                flightDate: vm.chargeDate,
                airline: vm.chargeAirline,
                chargeWeight: vm.chargeWeights,
                volume: vm.chargeVolume,
                packagingType: vm.chargeType,
                density: vm.chargeDensity,
                orderby: '',
                orderbyDesc: '',
                types: 'on',
                logFlag: true,
                densitystr: '',
                transit: '',
            }
			if (pathname == '/product/query') {
				vm.$parent.preciseQuery(query)
			} else {
				vm.$router.push({
					name:'ProductQueryPage',
					query:{
						departure: vm.chargeDeparture,
						destination: vm.chargeDestination,
						flightdate: vm.chargeDate,
						airline: vm.chargeAirline,
						chargeWeight: vm.chargeWeights,
						volume: vm.chargeVolume,
						chargeCount: vm.chargeCounts,
						packagingtype: vm.chargeType,
						density: vm.chargeDensity,
						yunModel: vm.yunModel,
					}
				})
			}

		},
		pickerdate: function (flightdate) {
			var vm = this;
			if (flightdate) {
				vm.chargeDate = flightdate.getFullYear() + '-' + Number(flightdate.getMonth() + 1) + '-' + flightdate.getDate();
			} else {
				vm.chargeDate = '';
			}
		},
		// 始发目的
		updateDeparture: function (departure) {
			this.chargeDeparture = departure
			// debugger
		},
		updateDestination: function (destination) {
			this.chargeDestination = destination
		},
		airLineInputChangeHandler: function (query) {
			var vm = this;
			vm.airline = query;
			vm.airLineOptions = [];
			if (query) {
				var patt = "^" + query.toUpperCase();
				var reg = new RegExp(patt, "");
				var dbAirLineOptions = this.airlineDB.where(function (obj) {
					return !!reg.test(obj.c);
				});
				for(let u of dbAirLineOptions) {
					vm.airLineOptions.push({
						code: u.c,
						titleZH: u.t,
					})
				}
				(vm.airLineOptions.length == 1) && (vm.airline = vm.airLineOptions[0].code)
			}
		},
		// 密度计算
		weightChangeHandler: function (event) {
			if (event != this.chargeWeights) {
				if (event) {
					this.chargeWeights = Number(event).toFixed(2);
				}
			}
			if (event) {
				this.chargeWeights = Number(event).toFixed(2);
			}
			if (event <= 0) {
				this.chargeWeights = Number(Math.abs(event)).toFixed(2);
			}
			this.updateChargeWeight();
			this.updateProportion();
		},
		volumeChangeHandler: function (event) {
			if (event != this.chargeVolume) {
				if (event) {
					this.chargeVolume = Number(event).toFixed(2);
				}
			}
			if (event) {
				this.chargeVolume = Number(event).toFixed(2);
			}
			if (event <= 0) {
				this.chargeVolume = Number(Math.abs(event)).toFixed(2);
			}
			this.updateChargeWeight();
			this.updateProportion();
		},
		updateChargeWeight: function () {
			var totalGrossWeight = this.chargeWeights;
			var volume = this.chargeVolume;
			if (!totalGrossWeight) totalGrossWeight = 0;
			if (!volume) volume = 0;
			// var volumeWeight = (
			// 	(Math.round((volume * 1000000) / 60) * 1.0) /
			// 	100
			// ).toFixed(2);
			var volumeWeight =Math.ceil((volume * 1000000) / 6000)
			this.chargeCounts = Math.max(totalGrossWeight, volumeWeight);
			if (this.chargeCounts == 0) {
				this.chargeCounts = "";
			}
		},
		updateProportion: function () {
			var density = parseInt(parseFloat(this.chargeWeights) / parseFloat(this.chargeVolume));
			this.chargeDensity= density ? density :''
		},
	}
};
</script>
